export default {
  pending: (state) => state.pending,
  list: (state) => JSON.parse(JSON.stringify([...state.list]))
};
